import {fetchGet} from "../../requests/NetworkRequestAuth0";
import {uri} from "./AppRequest";

export const findVenueBuyPackages = (
    venueId,
    successMethod,
    errorMethod,
    getAccessToken
) => {
    fetchGet(
        uri + "/user/venue/" + venueId + "/buy/packages",
        successMethod,
        errorMethod,
        getAccessToken);
};

export const findVenueDancePackages = (
    venueId,
    successMethod,
    errorMethod,
    getAccessToken
) => {
    fetchGet(
        uri + "/user/venue/" + venueId + "/dance/packages",
        successMethod,
        errorMethod,
        getAccessToken);
};

export const findVenueDrinkPackages = (
    venueId,
    successMethod,
    errorMethod,
    getAccessToken
) => {
    fetchGet(
        uri + "/user/venue/" + venueId + "/drink/packages",
        successMethod,
        errorMethod,
        getAccessToken);
};

export const findVenueSellPackages = (
    venueId,
    successMethod,
    errorMethod,
    getAccessToken
) => {
    fetchGet(
        uri + "/venue/" + venueId + "/sell/packages",
        successMethod,
        errorMethod,
        getAccessToken);
};

export const findVenueSellDancePackages = (
    venueId,
    successMethod,
    errorMethod,
    getAccessToken
) => {
    fetchGet(
        uri + "/venue/" + venueId + "/sell/dance/packages",
        successMethod,
        errorMethod,
        getAccessToken);
};

export const findVenueSellDrinkPackages = (
    venueId,
    successMethod,
    errorMethod,
    getAccessToken
) => {
    fetchGet(
        uri + "/venue/" + venueId + "/sell/drink/packages",
        successMethod,
        errorMethod,
        getAccessToken);
};